import React from "react";

export default function Description({
  title,
  descripcion,
  marcas,
  frase,
  url_back,
}) {
  return (
    <div className="descripcion">
      <a href={url_back} className="url_back">
        Volver
      </a>
      <h1>
        {title}
        <span className="line"></span>
      </h1>
      {descripcion &&
        descripcion !== "" &&
        descripcion.map((item, index) => <p key={index}>{item}</p>)}
      {!marcas &&
        marcas !== "" &&
        marcas.map((item, index) => (
          <img
            src={item}
            key={index}
            style={{ width: 80 + "px", padding: 5 + "px" }}
            alt=""
          />
        ))}
      <p>"{frase}"</p>
    </div>
  );
}
